module.exports = __webpack_public_path__ + "static/img/icon-vip2.597ce46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-vip2.png
// module id = zOX7
// module chunks = 1